import React from 'react';

const NotFoundPage: React.FC = () => <h1>404</h1>;

export default NotFoundPage;
